import { Container, LinearProgress, makeStyles } from '@material-ui/core';
import { AlertTitle } from '@material-ui/lab';
import { ProgressButton, useSnackbar } from '@ngt/forms';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Permissions, SaveQuickLinkGroups } from '../api/dtos';
import GroupList from '../components/GroupedCards/GroupList';
import AuthenticationContext from '../contexts/AuthenticationContext';
import FormsContext from "../contexts/FormsContext";
import useQuickLinkGroups from '../hooks/useQuickLinkGroups';
import { hasPermission } from '../utilities/auth';
const useStyles = makeStyles(theme => ({
  relativeWrapper: {
    position: 'relative'
  },
  stickyWrapper: {
    position: 'sticky',
    top: 0,
    right: 0,
    '@media (max-width: 1780px)': {
      display: 'none'
    }
  },
  absoluteWrapper: {
    //position: 'absolute',
    right: 0,
    top: 0,
    padding: theme.spacing(1),
    '& > *': {
      width: 120
    },
    textAlign: 'right',
    marginBottom: -68.5
  },
  containerWrapper: {
    marginTop: 1
  }
}));
export const Home: React.FunctionComponent<any> = () => {
  const classes = useStyles();
  const [editMode, setEditMode] = useState(false);
  const [saving, setSaving] = useState(false);
  const authedUser = useContext(AuthenticationContext);
  const forms = useContext(FormsContext);
  const {
    data,
    adGroups,
    loading
  } = useQuickLinkGroups(editMode, editMode ? {
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  } : undefined);
  const [items, setItems] = useState(data ?? []);
  useEffect(() => {
    setItems(data ?? []);
  }, [data, setItems]);
  const [expanded, setExpanded] = useState<Record<string, boolean>>(() => {
    const storedData = localStorage.getItem("expanded-quicklinks");
    if (!storedData) {
      return {};
    }
    return JSON.parse(storedData);
  });
  const toggleExpanded = useCallback((id: string) => {
    setExpanded(currentExpanded => {
      const newExpanded = {
        ...currentExpanded,
        [id]: !(currentExpanded[id] !== false)
      };
      localStorage.setItem("expanded-quicklinks", JSON.stringify(Object.keys(newExpanded).filter(x => !x.startsWith('group-')).reduce<Record<string, boolean>>((a, b) => {
        a[b] = newExpanded[b];
        return a;
      }, {})));
      return newExpanded;
    });
  }, [setExpanded]);
  const {
    enqueueSnackbar
  } = useSnackbar();
  const buttons = <div className={classes.absoluteWrapper}>
			{!editMode && <ProgressButton variant="contained" color="secondary" fullWidth onClick={() => setEditMode(_c => true)}>
						Edit
					</ProgressButton>}
			{editMode && <>
						<ProgressButton variant="contained" color="secondary" fullWidth loading={saving} onClick={async () => {
        setSaving(true);
        try {
          await forms.client.post(new SaveQuickLinkGroups({
            data: items
          }));
          setEditMode(_c => false);
          enqueueSnackbar(<>
											<AlertTitle>
												Save Successful!
											</AlertTitle>
											The quick links have been successfully saved.
										</>, {
            variant: 'success'
          });
        } catch {
          enqueueSnackbar(<>
											<AlertTitle>
												Save Failed!
											</AlertTitle>
											An error occurred while attempting to save the quick links.
										</>, {
            variant: 'error'
          });
        }
        setSaving(false);
      }}>
							Save
						</ProgressButton>
						<ProgressButton variant="contained" style={{
        marginLeft: 8
      }} fullWidth onClick={() => setEditMode(_c => false)} loading={saving}>
							Cancel
						</ProgressButton>
					</>}
		</div>;

  // const testRef = useRef();
  return <div className={classes.relativeWrapper} data-sentry-component="Home" data-sentry-source-file="Home.tsx">
			{loading && <LinearProgress color="secondary" />}
			{hasPermission(authedUser?.permissions, Permissions.EditQuickLinks) && <div className={classes.stickyWrapper}>
						{buttons}
					</div>}
			<DndProvider backend={HTML5Backend} data-sentry-element="DndProvider" data-sentry-source-file="Home.tsx">
				<Container className={classes.containerWrapper} data-sentry-element="Container" data-sentry-source-file="Home.tsx">
					{/* <div ref={testRef} />
      <IconPicker anchorRef={testRef} open={true} onClose={() => {}}/> */}
					<GroupList expanded={expanded} toggleExpanded={toggleExpanded} items={items} setItems={setItems} context={{
          editMode: editMode ?? false,
          level: 1,
          adGroups: adGroups ?? [],
          saving
        }} data-sentry-element="GroupList" data-sentry-source-file="Home.tsx" />
					{/* <IntranetLinkCardList editMode={editMode} /> */}
				</Container>
			</DndProvider>
			{hasPermission(authedUser?.permissions, Permissions.EditQuickLinks) && buttons}
		</div>;
};